module.exports = __webpack_public_path__ + "img/banner-2.33f239d3.png";